import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { AlertController, ModalController } from "@ionic/angular";
import { JobFollowUpService } from 'src/app/shared/modals/job-follow-up/job-follow-up.service';
import { isEmpty, isNil } from "lodash";
import { JobStatus } from "src/app/shared/modals/job-follow-up/enums/job-status.enum";
import { map } from 'rxjs/operators';
import { TranslationService } from '../../services/translation.service';
import { JobParams } from './models/jobs';
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';

@Component({
    selector: 'app-job-follow-up',
    templateUrl: './job-follow-up.component.html',
    styleUrls: ['./job-follow-up.component.scss'],
})
export class JobFollowUpComponent implements OnInit {
    public JobStatus = JobStatus;
    @Input() public cycleId: number;
    @Input() public title: string = 'job.follow-up.title';
    @Input() public jobGroup: number = 0;
    @Input() public pageComponentName: string = '';
    @Input() public filterByPage: boolean = true;
    @Output() public emailRequested = new EventEmitter<JobParams>();
    public jobStatusEnum = JobStatus;
    public isEmailFeatureEnabled = false;

    public get jobs() {
        if(!this.filterByPage) {
        return this._jobFollowUpService.jobs$.pipe(
                map(jobs => jobs
                    .sort((a, b) => {
                        const aTime = a.createdAt || Number(a.jobId) || 0;
                        const bTime = b.createdAt || Number(b.jobId) || 0;
                        return bTime - aTime;
                    }))
        );
        } else {
            return this._jobFollowUpService.jobs$.pipe(
                map(jobs => jobs
                    .filter(job =>
                        (job.cycleId == this.cycleId && job.group == this.jobGroup)
                        || this.pageComponentName == job.pageComponentName
                    )
                    .sort((a, b) => {
                        const aTime = a.createdAt || Number(a.jobId) || 0;
                        const bTime = b.createdAt || Number(b.jobId) || 0;
                        return bTime - aTime;
                    }))
            );
        }
    }

    constructor(private _jobFollowUpService: JobFollowUpService,
                private _modalController: ModalController,
                private _alertController: AlertController,
                private _translationService: TranslationService,
                private _configService: ConfigService
    ) {
        this.isEmailFeatureEnabled = this._configService.settings.features.enableEmailSendModal;
    }

    ngOnInit() {
    }

    public save() {
        this.dismiss();
    }

    public clear() {

    }

    public close() {
        this.dismiss();
    }

    private dismiss() {
        this._modalController.dismiss();
    }


    public goToUrl(url: string) {
        if (isNil(url) || isEmpty(url)) return;
        window.open(url, '_blank');
    }

    public isnan(value: any): boolean {
        return isNaN(value);
    }

    public async confirmDeleteJob(job: JobParams): Promise<void> {
        const jobName = this._translationService.getTranslation(job.jobName);
        const jobMessage = "Confirma a remoção do acompanhamento do progresso de:";
        const msgObs = "Se o processo for concluído com sucesso, o resultado ainda será enviado por e-mail normalmente.";
        const alert = await this._alertController.create({
            message: jobMessage + `<br/><strong>${jobName}</strong>` + `<br/><br/>` + `<small>${msgObs}</small>`,
            buttons: [
                {
                    text: this._translationService.getTranslation('generic.no'),
                    role: 'cancel',
                    cssClass: 'danger',
                },
                {
                    text: this._translationService.getTranslation('generic.yes'),
                    handler: () => {
                        this._jobFollowUpService.deleteJob(job.jobId);
                    },
                },
            ],
        });

        await alert.present();
    }

    public openEmailModal(job: JobParams): void {
        if (!this.isEmailFeatureEnabled) {
            return;
        }
        this.emailRequested.emit(job);
    }
}
